import { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { CREATE_LEAD } from '../../services/graphql/mutations/createLead'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import { selectMe } from '../../features/auth/authReducer'
import { useTranslation } from 'next-i18next'
import FriendlyCaptcha from '../FriendlyCaptcha'
import { useRouter } from 'next/router'

export default function ContactForm ({ company, onSend }) {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [subject, setSubject] = useState('')
  const [description, setDescription] = useState('')
  const [createLead] = useMutation(CREATE_LEAD)
  const [solution, setSolution] = useState('')
  const me = useSelector(state => selectMe(state.auth))
  const { t } = useTranslation(['seller'])
  const router = useRouter()

  // Set given router subject
  useEffect(() => {
    if (!router.query.contactSubject) {
      return
    }

    setSubject(router.query.contactSubject)
  }, [])

  const resetFields = () => {
    setName('')
    setSubject('')
    setEmail('')
    setDescription('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      await createLead({
        variables: {
          input: {
            name,
            subject,
            subject_id: company.id,
            email,
            description,
            company_id: company.id,
            user_id: me?.id,
            type: 'CONTACT',
            ref_link: localStorage.getItem('ref') || null,
            solution
          }
        }
      })

      setName('')
      setSubject('')
      setEmail('')
      setDescription('')

      toast.success(t('detail.form.success'))
      resetFields()

      if (onSend) {
        onSend(true)
      }
    } catch (e) {
      toast.error(t('detail.form.error'))
    }
  }

  return (
    <div
      className="row justify-content-lg-between align-items-center gap-2"
      id="sellerContactForm"
    >
      <div className="col-12">
        <div className="row g-3 my-2">
          <div className="col-lg-6">
            <h3 className="text-dark">
              {t('detail.form.title')}
            </h3>
          </div>
        </div>
        <form onSubmit={e => handleSubmit(e)}>
          <div className="row g-3 my-2">
            <div className="col-lg-6">
              <input
                required
                type="text"
                placeholder={t('detail.form.name')}
                className="form-control h-100"
                id="name"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="col-lg-6">
              <input
                type="text"
                placeholder={t('detail.form.email')}
                className="form-control h-100"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row g-3 my-2">
            <div className="col-lg-12">
              <input
                type="text"
                placeholder={t('detail.form.subject')}
                className="form-control h-100"
                value={subject}
                onChange={e => setSubject(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row g-3 my-2">
            <div className="col-lg-12">
              <textarea
                rows="5"
                placeholder={t('detail.form.description')}
                className="form-control h-100"
                value={description}
                onChange={e => setDescription(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="row g-3 my-2">
            <div className="col-12 col-lg-4">
              <FriendlyCaptcha
                onResponse={e => setSolution(e)}
              />
            </div>
            {
              solution && (
                <div className="col-12 col-lg-2">
                  <input
                    type="submit"
                    value={t('detail.form.submit')}
                    className="btn btn-primary w-100 h-100"
                  />
                </div>
              )
            }
          </div>
        </form>
      </div>
    </div>
  )
}
